
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2OtFZ", function(module, exports) {
/* eslint-disable @atlaskit/platform/use-recommended-utils */ 
var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $4OGlb = parcelRequire("4OGlb");


var $iA4lt = parcelRequire("iA4lt");


var $6Gsan = parcelRequire("6Gsan");


var $b4tvS = parcelRequire("b4tvS");


var $9d9t8 = parcelRequire("9d9t8");

const $d1337898ab272d64$export$de65f9bad07950f2 = ()=>{
    (0, $c6GJD.default).manuallyLogExperimentExposure('enable_google_drive_impersonation_search_in_fps');
};
const $d1337898ab272d64$export$6c232948b0f89805 = ()=>{
    return (0, $c6GJD.default).getExperimentValue('enable_google_drive_impersonation_search_in_fps', 'cohort', 'control', {
        fireExperimentExposure: false
    }) === 'test';
};
const $d1337898ab272d64$export$9f3b4e44245ab299 = (thirdPartyConfigs, isAllProductSearch)=>{
    const isSlackAuthenticated = !thirdPartyConfigs?.[(0, $b4tvS.ProductKeys3P).Slack]?.userNeedsOAuth;
    const hasFederatedConnectorSource = thirdPartyConfigs?.[(0, $b4tvS.ProductKeys3P).Slack]?.connectorSources?.includes((0, $9d9t8.FEDERATED_CONNECTOR_SOURCE));
    const isUserEligible = isSlackAuthenticated && hasFederatedConnectorSource && isAllProductSearch;
    return isUserEligible;
};
const $d1337898ab272d64$export$b8eda33c6a73a867 = (fireExperimentExposure = false)=>{
    return (0, $c6GJD.default).getExperimentValue('rovosearch_noun_result_counts', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    }) === 'test';
};
const $d1337898ab272d64$export$6cc04d45455a2e52 = (fireExperimentExposure = false)=>{
    return (0, $c6GJD.default).getExperimentValue('web_pages_type_filter_bug', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    }) === 'test';
};
const $d1337898ab272d64$export$1b405ed1dcef1833 = ()=>{
    return (0, $c6GJD.default).getExperimentValue('qf_jira_recents_exclude_confluence', 'cohort', 'control', {
        fireExperimentExposure: false
    }) === 'test';
};
const $d1337898ab272d64$export$dbfae5c8d94a4c99 = (primaryProduct, { fireLayerExposure: fireLayerExposure = true } = {})=>{
    if (primaryProduct !== (0, $6Gsan.PrimaryProductKeys).Jira) return false;
    const layer = (0, $iA4lt.getMutuallyExclusiveUIExperiment)('rovo_qf_filter_suggestion_exp', 'rovo_search_qf_experience_layer', {
        fireLayerExposure: fireLayerExposure
    });
    return layer?.get('isFilterSuggestionEnabled', false, (value)=>typeof value === 'boolean') ?? false;
};
const $d1337898ab272d64$export$df1791a16917f9c3 = ()=>{
    return (0, $c6GJD.default).getExperimentValue('search_user_right_rail_3p_personalization_v1', 'cohort', 'control', {
        fireExperimentExposure: true
    }) === 'test';
};
const $d1337898ab272d64$export$a254d1715475fc25 = ()=>{
    return (0, $c6GJD.default).getExperimentValue('quick-find-3p-banner', 'bannerType', 'control') !== 'control';
};
const $d1337898ab272d64$export$6308fede6bfa9216 = ()=>{
    return (0, $c6GJD.default).getExperimentValue('quick-find-3p-banner', 'bannerType', 'control', {
        fireExperimentExposure: false
    }) !== 'control';
};
const $d1337898ab272d64$export$a28677150905172f = ()=>{
    return (0, $c6GJD.default).getExperimentValue('confluence_space_icon_update', 'isEnabled', false) === true;
};
const $d1337898ab272d64$export$f980294cad954499 = (thirdPartyConfigs, options = {
    fireExperimentExposure: true
})=>{
    const isEligible3PUser = Object.keys(thirdPartyConfigs).some((productKey)=>thirdPartyConfigs[productKey]?.userNeedsOAuth === false);
    return isEligible3PUser && (0, $c6GJD.default).getExperimentValue('3p_clicks_in_fps_as_qf_recents', 'cohort', 'control', options) === 'test';
};
const $d1337898ab272d64$export$7d99be50af8e6e5c = ()=>(0, $c6GJD.default).getExperimentValue('rovo_search_preload_from_quick_find_using_async', 'isEnabled', false) === true;
const $d1337898ab272d64$export$32815557e5d06f0a = ({ fireExperimentExposure: fireExperimentExposure = false } = {})=>{
    return (0, $c6GJD.default).getExperimentValue('quick_find_3p_boosting_experiment', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    }) === 'test';
};
const $d1337898ab272d64$export$752769d90d201b0a = ()=>{
    return (0, $c6GJD.default).getExperimentValue('afm_customer_contact_search_type_experiment', 'cohort', 'control') === 'test';
};
const $d1337898ab272d64$export$307ab554c0a03fb = ()=>{
    // Check the targeting FG first. This is technically not needed, but makes VR testing much easier
    // since the Gemini framework has full support for FGs, but not Statsig experiments.
    if (!(0, $dh538.fg)('rovo_search_improve_engagement_tracking_gate')) return false;
    return (0, $c6GJD.default).getExperimentValue('rovo_search_improve_engagement_tracking', 'cohort', 'control', {
        fireExperimentExposure: false
    }) === 'test';
};
const $d1337898ab272d64$export$99df3e6ef07f806c = ()=>{
    // Check the targeting FG first. This is technically not needed, but makes VR testing much easier
    // since the Gemini framework has full support for FGs, but not Statsig experiments.
    if (!(0, $dh538.fg)('rovo_search_improve_engagement_tracking_gate')) return;
    (0, $c6GJD.default).manuallyLogExperimentExposure('rovo_search_improve_engagement_tracking');
};
/**
 * >>> Confluence QuickFind UserShard Search Experiments
 *
 * We have 2 separated experiments: one is for hello tenant, the other is for 24 non-hello tenants.
 *
 * Experiment: `quick-find-user-shard-search-experiment`
 * + hello only
 * + statsig_url = https://go/statsig/experiments/quick-find-user-shard-search-experiment
 *
 * Experiment: `confluence-quickfind-usershard-nonhello-exp`
 * + 24 non-hello tenants
 * + statsig_url = https://go/statsig/experiments/confluence-quickfind-usershard-nonhello-exp
 *
 * These experiments have 3 groups:
 * + cohort = 'control', the current product.
 * + cohort = 'model-only', the model is served without any changes to the UI.
 * + cohort = 'test', both the model and new UI are served.
 *
 */ const $d1337898ab272d64$var$USER_SHARD_EXPERIMENTS = [
    'quick-find-user-shard-search-experiment',
    'confluence-quickfind-usershard-nonhello-exp'
];
const $d1337898ab272d64$var$getValidDebounceTimeout = (value)=>{
    if (typeof value !== 'number' || Number.isNaN(value) || !Number.isFinite(value)) return undefined;
    return value >= 0 ? value : undefined;
};
const $d1337898ab272d64$var$getUserShardExperimentDetails = ()=>{
    for (const experimentName of $d1337898ab272d64$var$USER_SHARD_EXPERIMENTS){
        const experiment = (0, $iA4lt.getMutuallyExclusiveUIExperiment)(experimentName, (0, $4OGlb.STATSIG_QUICK_FIND_LAYER), {
            fireLayerExposure: false
        });
        if (experiment !== undefined) return {
            cohort: experiment.get('cohort', undefined),
            spaceL1Id: experiment.get('spaceL1Id', undefined),
            pageL1Id: experiment.get('pageL1Id', undefined),
            debounceTimeout: $d1337898ab272d64$var$getValidDebounceTimeout(experiment.get('debounceTimeout', undefined))
        };
    }
    return {
        cohort: undefined,
        spaceL1Id: undefined,
        pageL1Id: undefined,
        debounceTimeout: undefined
    };
};
const $d1337898ab272d64$export$995378c845be3fef = ()=>{
    const { cohort: cohort } = $d1337898ab272d64$var$getUserShardExperimentDetails();
    return {
        serveModel: cohort === 'model-only' || cohort === 'test',
        serveUI: cohort === 'test',
        serveControl: cohort === 'control',
        cohort: cohort
    };
};
const $d1337898ab272d64$export$2300db9903c1302f = ()=>{
    return $d1337898ab272d64$export$995378c845be3fef().serveModel;
};
const $d1337898ab272d64$export$d9ee534a20391486 = ()=>{
    return $d1337898ab272d64$export$995378c845be3fef().serveUI;
};
const $d1337898ab272d64$export$1c3bd8b8866d2939 = ()=>{
    return $d1337898ab272d64$export$995378c845be3fef().serveControl;
};
const $d1337898ab272d64$export$3b350d5272fcff38 = ()=>{
    return $d1337898ab272d64$var$getUserShardExperimentDetails().spaceL1Id;
};
const $d1337898ab272d64$export$28bf0ffbee49739c = ()=>{
    return $d1337898ab272d64$var$getUserShardExperimentDetails().pageL1Id;
};
const $d1337898ab272d64$export$d8621fd9027f7208 = ()=>{
    return $d1337898ab272d64$var$getUserShardExperimentDetails().debounceTimeout;
};
const $d1337898ab272d64$export$9e14285db0210414 = (experimentConfig)=>{
    const cohort = experimentConfig.frontendExperiments?.['multi_site_search_in_rovo']?.cohort;
    return cohort === 'test';
};
const $d1337898ab272d64$export$45bf6049ec3ec516 = ()=>{
    return (0, $c6GJD.default).getExperimentValue('unified_search_one_click_3p_connect', 'isEnabled', false) === true;
};
/**
 * Unified Search 3P Connect Improvements Experiment
 */ const $d1337898ab272d64$var$UNIFIED_SEARCH_3P_CONNECT_IMPROVEMENTS_TEST_COHORTS = [
    'icon-and-tooltip',
    'icon-only',
    'tooltip-only'
];
const $d1337898ab272d64$export$1abc158ee6a5b777 = [
    'control',
    ...$d1337898ab272d64$var$UNIFIED_SEARCH_3P_CONNECT_IMPROVEMENTS_TEST_COHORTS
];
const $d1337898ab272d64$export$28f6b85de12145ce = ()=>{
    const cohort = (0, $c6GJD.default).getExperimentValue('unified_search_3p_connect_improvements', 'cohort', 'control');
    if ($d1337898ab272d64$export$1abc158ee6a5b777.includes(cohort)) return cohort;
    return 'control';
};
const $d1337898ab272d64$export$f22ea87ae194d314 = ()=>{
    const cohort = $d1337898ab272d64$export$28f6b85de12145ce();
    return $d1337898ab272d64$var$UNIFIED_SEARCH_3P_CONNECT_IMPROVEMENTS_TEST_COHORTS.includes(cohort);
};
const $d1337898ab272d64$var$IMPROVE_BANNER_TARGETING_COHORTS = [
    'control',
    'usage-threshold',
    'max-dismissals'
];
const $d1337898ab272d64$export$647c2f5a2b1ce3a5 = ({ fireExperimentExposure: fireExperimentExposure = true } = {})=>{
    const cohort = (0, $c6GJD.default).getExperimentValue('rovo_search_improve_banner_targeting', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    });
    if ($d1337898ab272d64$var$IMPROVE_BANNER_TARGETING_COHORTS.includes(cohort)) return cohort;
    return 'control';
};
const $d1337898ab272d64$export$a188fe5ccb37cfe6 = (options = {
    fireExperimentExposure: false
})=>{
    return (0, $c6GJD.default).getExperimentValue('quick_find_zero_query_allocation_experiment', 'cohort', 'control', options) === 'test';
};
const $d1337898ab272d64$var$INLINE_3P_QUERY_SUGGESTIONS_TREATMENTS = [
    'control',
    'static',
    'dynamic'
];
const $d1337898ab272d64$export$1a051b8e8c16594f = ({ fireExperimentExposure: fireExperimentExposure = true } = {})=>{
    const treatment = (0, $c6GJD.default).getExperimentValue('inline_3p_query_suggestions_phase_1', 'inline_3p_query_suggestions_treatment', 'control', {
        fireExperimentExposure: fireExperimentExposure
    });
    if ($d1337898ab272d64$var$INLINE_3P_QUERY_SUGGESTIONS_TREATMENTS.includes(treatment)) return treatment;
    return 'control';
};
const $d1337898ab272d64$export$e4fdf56860b85064 = ()=>{
    return (0, $c6GJD.default).getExperimentValue('unified_search_right_rail_enhancements', 'cohort', 'control');
};
const $d1337898ab272d64$export$faafa351c854e058 = ({ fireExperimentExposure: fireExperimentExposure = true } = {})=>(0, $c6GJD.default).getExperimentValue('rovo_search_settings_modal_enabled', 'isEnabled', false, {
        fireExperimentExposure: fireExperimentExposure
    });
const $d1337898ab272d64$export$5526c331b5a2a0a4 = (options = {
    fireExperimentExposure: false
})=>{
    return (0, $c6GJD.default).getExperimentValue('quick_find_zero_query_3p_recs_experiment', 'isEnabled', false, options) === true;
};
const $d1337898ab272d64$export$6d6007cc7a6767d0 = ({ fireExperimentExposure: fireExperimentExposure = false } = {})=>{
    return (0, $c6GJD.default).getExperimentValue('rovo_search_github_in_recents', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    }) === 'test';
};
const $d1337898ab272d64$export$ba9c92ff563d2704 = ({ fireExperimentExposure: fireExperimentExposure = false } = {})=>{
    return (0, $c6GJD.default).getExperimentValue('rovo_search_github_issues_in_recents', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    }) === 'test';
};
const $d1337898ab272d64$export$1c4aca11d3a542d8 = ({ fireExperimentExposure: fireExperimentExposure = false } = {})=>{
    return (0, $c6GJD.default).getExperimentValue('rovo_search_use_sl_clicked_only_in_recents', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    }) === 'test';
};
const $d1337898ab272d64$var$FULLPAGE_SEARCH_SUMMARIZE_BUTTON_REVAMP_TREATMENTS = [
    'control',
    'visibility',
    'border'
];
const $d1337898ab272d64$export$b67def2b3de3898b = ({ fireExperimentExposure: fireExperimentExposure = true } = {})=>{
    const treatment = (0, $c6GJD.default).getExperimentValue('fullpage_search_summarize_button_revamp', 'fullpage_search_summarize_button_revamp_treatment', 'control', {
        fireExperimentExposure: fireExperimentExposure
    });
    if ($d1337898ab272d64$var$FULLPAGE_SEARCH_SUMMARIZE_BUTTON_REVAMP_TREATMENTS.includes(treatment)) return treatment;
    return 'control';
};
module.exports["triggerExposureForWeakLinkExp"] = $d1337898ab272d64$export$de65f9bad07950f2;
module.exports["serveWeakLinkExpWithoutExposure"] = $d1337898ab272d64$export$6c232948b0f89805;
module.exports["removeFedSlackFromAllProductSearch"] = $d1337898ab272d64$export$9f3b4e44245ab299;
module.exports["serveNounResultCounts"] = $d1337898ab272d64$export$b8eda33c6a73a867;
module.exports["serveWebPagesInTypeFilter"] = $d1337898ab272d64$export$6cc04d45455a2e52;
module.exports["serveJiraRecentsExcludeConfluenceWithoutExposure"] = $d1337898ab272d64$export$1b405ed1dcef1833;
module.exports["serveQFFilterSuggestionExperiment"] = $d1337898ab272d64$export$dbfae5c8d94a4c99;
module.exports["serveRightRailRecommendationsImprovementsWithExposure"] = $d1337898ab272d64$export$df1791a16917f9c3;
module.exports["serveQF3PBannerExperiment"] = $d1337898ab272d64$export$a254d1715475fc25;
module.exports["serveQF3PBannerExperimentWithoutExposure"] = $d1337898ab272d64$export$6308fede6bfa9216;
module.exports["serveConfluenceSpaceIconUpdate"] = $d1337898ab272d64$export$a28677150905172f;
module.exports["serve3PClickIngestionExperiment"] = $d1337898ab272d64$export$f980294cad954499;
module.exports["isQuickFindAsyncPreloadEnabled"] = $d1337898ab272d64$export$7d99be50af8e6e5c;
module.exports["serveQuickFind3PBoostingExperiment"] = $d1337898ab272d64$export$32815557e5d06f0a;
module.exports["serveEngagementTrackingImprovementsExperiment"] = $d1337898ab272d64$export$307ab554c0a03fb;
module.exports["triggerExposureForEngagementTrackingImprovementsExperiment"] = $d1337898ab272d64$export$99df3e6ef07f806c;
module.exports["getUserShardExperimentFlags"] = $d1337898ab272d64$export$995378c845be3fef;
module.exports["serveUserShardModel"] = $d1337898ab272d64$export$2300db9903c1302f;
module.exports["serveUserShardUI"] = $d1337898ab272d64$export$d9ee534a20391486;
module.exports["serveUserShardControl"] = $d1337898ab272d64$export$1c3bd8b8866d2939;
module.exports["getUserShardSpaceL1Id"] = $d1337898ab272d64$export$3b350d5272fcff38;
module.exports["getUserShardPageL1Id"] = $d1337898ab272d64$export$28bf0ffbee49739c;
module.exports["getUserShardDebounceTimeout"] = $d1337898ab272d64$export$d8621fd9027f7208;
module.exports["getMultiSiteSearchInRovo"] = $d1337898ab272d64$export$9e14285db0210414;
module.exports["serveOneClick3PConnectExperiment"] = $d1337898ab272d64$export$45bf6049ec3ec516;
module.exports["getUnifiedSearch3PConnectImprovementsCohort"] = $d1337898ab272d64$export$28f6b85de12145ce;
module.exports["isInUnifiedSearch3PConnectImprovementsTestCohort"] = $d1337898ab272d64$export$f22ea87ae194d314;
module.exports["serveImproveBannerTargetingExperiment"] = $d1337898ab272d64$export$647c2f5a2b1ce3a5;
module.exports["serveQFZeroQueryAllocationExperiment"] = $d1337898ab272d64$export$a188fe5ccb37cfe6;
module.exports["serveInline3PQuerySuggestionsPhase1"] = $d1337898ab272d64$export$1a051b8e8c16594f;
module.exports["getUnifiedSearchRightRailEnhancementsExpValue"] = $d1337898ab272d64$export$e4fdf56860b85064;
module.exports["serveSearchSettingsModalExperiment"] = $d1337898ab272d64$export$faafa351c854e058;
module.exports["serveQFZeroQuery3PRecsExperiment"] = $d1337898ab272d64$export$5526c331b5a2a0a4;
module.exports["serveGithubRecentsExperiment"] = $d1337898ab272d64$export$6d6007cc7a6767d0;
module.exports["serveGithubWorkItemsRecentsExperiment"] = $d1337898ab272d64$export$ba9c92ff563d2704;
module.exports["serveSlClickedOnlyInRecentsExperiment"] = $d1337898ab272d64$export$1c4aca11d3a542d8;
module.exports["serveFullpageSearchSummarizeButtonRevamp"] = $d1337898ab272d64$export$b67def2b3de3898b;

});

parcelRegister("6Gsan", function(module, exports) {
const $af14923fe5fc3bcc$export$15d12effc8830544 = {
    // Fully supported as GA
    Atlas: 'townsquare',
    Confluence: 'confluence',
    // In development
    Assets: 'cmdb',
    Focus: 'mercury',
    Jira: 'jira',
    Elevate: 'elevate',
    Talent: 'radar',
    RovoExtension: 'rovo-extension'
};
module.exports["PrimaryProductKeys"] = $af14923fe5fc3bcc$export$15d12effc8830544;

});

parcelRegister("b4tvS", function(module, exports) {
$parcel$export(module.exports, "ProductsOrder3P", () => (parcelRequire("hdfeV")).ProductsOrder3P);
/**
 * Product key constants, types, and lightweight helpers.
 * No icons, no 3P configs, no React components.
 */ 
var $dh538 = parcelRequire("dh538");


var $20IWy = parcelRequire("20IWy");


var $hdfeV = parcelRequire("hdfeV");


const $6f142b1a5d666130$var$ProductKeys1P = {
    Atlas: 'townsquare',
    Bitbucket: 'bitbucket',
    Compass: 'compass',
    Confluence: 'confluence',
    Jira: 'jira',
    JiraProductDiscovery: 'jira-product-discovery',
    JiraServiceManagement: 'jira-servicedesk',
    Trello: 'trello',
    Focus: 'mercury',
    Assets: 'cmdb',
    // Can't add these until they're ready as we use this type to enforce that product configs are available for all products
    Talent: 'radar'
};
const $6f142b1a5d666130$export$252aae15ddb3591c = {
    ...$6f142b1a5d666130$var$ProductKeys1P,
    Loom: 'loom',
    AtlasGoals: 'goals',
    AtlasProjects: 'projects',
    AtlasTeams: 'teams'
};
const $6f142b1a5d666130$export$ef2c0ffddaaaf76c = {
    ...$6f142b1a5d666130$var$ProductKeys1P,
    ...(0, $hdfeV.ProductKeys3P)
};
const $6f142b1a5d666130$export$93aa518ca2694c2d = (0, $hdfeV.ProductKeys3P);
const $6f142b1a5d666130$var$localAllProductKeys = Object.values($6f142b1a5d666130$export$ef2c0ffddaaaf76c);
const $6f142b1a5d666130$export$57043b2770b3924d = Object.values((0, $hdfeV.ProductKeys3P));
const $6f142b1a5d666130$export$225f36a2f261b1e7 = Object.values($6f142b1a5d666130$var$ProductKeys1P);
const $6f142b1a5d666130$export$297680dde4e8aef1 = ()=>{
    if ((0, $dh538.fg)('rovo_fps_use_rovo_config')) return 0, $20IWy.allProductKeys;
    return $6f142b1a5d666130$var$localAllProductKeys;
};
const $6f142b1a5d666130$export$73be91b73ebbdb05 = $6f142b1a5d666130$var$localAllProductKeys;
const $6f142b1a5d666130$export$65f9ab1ba49d5e68 = (key)=>$6f142b1a5d666130$export$225f36a2f261b1e7.includes(key);
const $6f142b1a5d666130$export$ae4856d6227d0649 = (key)=>$6f142b1a5d666130$export$57043b2770b3924d.includes(key);
const $6f142b1a5d666130$export$2a41a819c1db85b1 = (key)=>{
    if (!key) return false;
    // Check hardcoded keys first
    if ($6f142b1a5d666130$export$297680dde4e8aef1().includes(key)) return true;
    // Treat any "forge-connector-*" string as valid ProductKeys to support
    // dynamically provisioned Forge connectors without updating this constant list.
    // This means isProductKey is *looser* than "is configured in ProductKeys".
    return key.startsWith('forge-connector-');
};
const $6f142b1a5d666130$export$ba4f56e768ae6f1e = [
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Confluence,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Jira
];
const $6f142b1a5d666130$export$64c23f2d9ef43822 = [
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Confluence,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Jira,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.JiraProductDiscovery,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.JiraServiceManagement,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Atlas,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Trello,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Bitbucket,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Compass,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Focus,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Assets,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Talent,
    ...(0, $hdfeV.ProductsOrder3P)
];
const $6f142b1a5d666130$export$41ecd101a1ccdccc = [
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Confluence,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Jira,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.JiraProductDiscovery,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.JiraServiceManagement,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Atlas,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Trello,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Bitbucket,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Compass,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Focus,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Talent,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Assets,
    ...(0, $hdfeV.NewProductsOrder3P)
];
module.exports["ProductKeys1PForAnalytics"] = $6f142b1a5d666130$export$252aae15ddb3591c;
module.exports["ProductKeys"] = $6f142b1a5d666130$export$ef2c0ffddaaaf76c;
module.exports["ProductKeys3P"] = $6f142b1a5d666130$export$93aa518ca2694c2d;
module.exports["all3pProductKeys"] = $6f142b1a5d666130$export$57043b2770b3924d;
module.exports["all1pProductKeys"] = $6f142b1a5d666130$export$225f36a2f261b1e7;
module.exports["getAllProductKeys"] = $6f142b1a5d666130$export$297680dde4e8aef1;
module.exports["allProductKeys"] = $6f142b1a5d666130$export$73be91b73ebbdb05;
module.exports["is1pProductKey"] = $6f142b1a5d666130$export$65f9ab1ba49d5e68;
module.exports["is3pProductKey"] = $6f142b1a5d666130$export$ae4856d6227d0649;
module.exports["isProductKey"] = $6f142b1a5d666130$export$2a41a819c1db85b1;
module.exports["productsSupportingEmptyQuery"] = $6f142b1a5d666130$export$ba4f56e768ae6f1e;
module.exports["PRODUCTS_ORDER"] = $6f142b1a5d666130$export$64c23f2d9ef43822;
module.exports["PRODUCTS_ORDER_WITH_3P_BY_POPULARITY"] = $6f142b1a5d666130$export$41ecd101a1ccdccc;

});

parcelRegister("20IWy", function(module, exports) {

var $gpcGZ = parcelRequire("gpcGZ");


var $78z3f = parcelRequire("78z3f");

const $ae6f87a91fe97442$export$73be91b73ebbdb05 = [
    ...Object.values((0, $gpcGZ.ProductKeys1P)),
    ...Object.values((0, $78z3f.ProductKeys3P))
];
module.exports["allProductKeys"] = $ae6f87a91fe97442$export$73be91b73ebbdb05;

});

parcelRegister("hdfeV", function(module, exports) {
/**
 * Pure 3P product key constants extracted for SSR bundle isolation.
 * No icon or config imports - just string mappings.
 *
 * This is the SOURCE OF TRUTH for ProductKeys3P.
 * 3p-product-configs/index.tsx and products.tsx re-export from here.
 */ const $2db55438f96b7ddd$export$93aa518ca2694c2d = {
    AtlassianWebCrawler: 'atlassian-web-crawler',
    Figma: 'figma',
    Github: 'github',
    GoogleDrive: 'drive',
    Loom: 'loom',
    OneDrive: 'onedrive',
    Dropbox: 'dropbox',
    Slack: 'slack',
    Sharepoint: 'sharepoint',
    Teams: 'teams',
    GoogleCalendar: 'google-calendar',
    OutlookCalendar: 'outlook-calendar',
    OutlookMail: 'outlook-mail',
    Gmail: 'gmail',
    AdobeSign: 'adobe-sign',
    Asana: 'asana',
    Zendesk: 'zendesk',
    Airtable: 'airtable',
    Smartsheet: 'smartsheet',
    Notion: 'notion',
    Miro: 'miro',
    Docusign: 'docusign',
    Lucid: 'lucid',
    Monday: 'monday',
    AzureDevops: 'azure-devops',
    Gitlab: 'gitlab',
    ConfluenceDC: 'confluence-dc',
    Canva: 'canva',
    Box: 'box',
    Zeplin: 'zeplin',
    ServiceNow: 'servicenow',
    Freshservice: 'freshservice',
    PowerBI: 'power-bi',
    ClickUp: 'clickup',
    Amplitude: 'amplitude',
    Stripe: 'stripe',
    AdobeXD: 'adobexd',
    Aha: 'aha',
    Mural: 'mural',
    Webex: 'webex',
    Todoist: 'todoist',
    PagerDuty: 'pagerduty',
    Pipedrive: 'pipedrive',
    Hubspot: 'hubspot',
    Dovetail: 'dovetail',
    LaunchDarkly: 'launchdarkly',
    Salesforce: 'salesforce',
    Sentry: 'sentry',
    JiraDC: 'jira-dc',
    Gitbook: 'gitbook',
    AWSS3: 'aws-s3',
    Databricks: 'databricks',
    JsmDC: 'jsm-dc',
    ForgeAdamVitareqDev: 'forge-connector-dAkghOClvWGokDftTTaIgNoD6pnNt74z-vitareq-connector',
    ForgeAdamVitareqProd: 'forge-connector-EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93-vitareq-connector',
    ForgeK15tScrollSitesDev: 'forge-connector-h1n3NRFAn84v7ECSONVidlCS88qZh8cy-scroll-sites-connector',
    ForgeK15tScrollSitesProd: 'forge-connector-ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO-scroll-sites-connector',
    ForgePioAwsDev: 'forge-connector-HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL-s3-connector',
    ForgePioAwsProd: 'forge-connector-mRcqWRwqkUd4JwapGkvGHUViyySX9MVy-s3-connector',
    ForgePioClickupDev: 'forge-connector-ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY-clickup-connector',
    ForgePioClickupProd: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector',
    ForgePioGitbookDev: 'forge-connector-Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi-gitbook-connector',
    ForgePioGitbookProd: 'forge-connector-cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u-gitbook-connector',
    ForgePioGithubDev: 'forge-connector-3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j-github-connector',
    ForgePioGithubProd: 'forge-connector-0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI-github-connector',
    ForgePioGitlabDev: 'forge-connector-psr1wBkasRuKCwsvwi4aTJNhjmlVFebC-gitlab-connector',
    ForgePioGitlabProd: 'forge-connector-QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL-gitlab-connector',
    ForgePioGoogleDriveDev: 'forge-connector-JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq-google-drive-connector',
    ForgePioGoogleDriveProd: 'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector',
    ForgePioGuruDev: 'forge-connector-NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5-guru-connector',
    ForgePioGuruProd: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector',
    ForgePioHelpjuiceDev: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector',
    ForgePioHelpjuiceProd: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector',
    ForgePioHubspotDev: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector',
    ForgePioHubspotProd: 'forge-connector-O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J-hubspot-connector',
    ForgePioSalesforceDev: 'forge-connector-50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo-salesforce-connector',
    ForgePioSalesforceProd: 'forge-connector-nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb-salesforce-connector',
    ForgePioSharepointDev: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector',
    ForgePioSharepointProd: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector',
    ForgePioStackOverflowDev: 'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector',
    ForgePioStackOverflowProd: 'forge-connector-vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS-stack-overflow-connector',
    ForgeUtoolityGitbookDev: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector',
    ForgeUtoolityGitbookProd: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector',
    ForgeGdriveEugeneTestDev: 'forge-connector-s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua-gdrive',
    ForgeGdriveEugeneTestProd: 'forge-connector-bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf-gdrive',
    ForgeUnitoSalesforceDev: 'forge-connector-h8rZu86YJHRfyVlmVeUR464Kuhz9OZvV-salesforce',
    ForgeUnitoSalesforceProd: 'forge-connector-qjk3Z8Kt2DWx29hdZHQapEYXAGCPIyd8-salesforce',
    ForgeUnitoServicenowDev: 'forge-connector-52qcnF9TIgxkDKY4OL7xNxAzcM0amb7q-servicenow',
    ForgeUnitoServicenowProd: 'forge-connector-RzFogW4EQLcXYmYpKkItRUhLAn3jETMq-servicenow',
    ForgeUnitoWrikeDev: 'forge-connector-gw0rFhQkj7PuTllmYdHbMaPw6jC18YvO-wrike',
    ForgeUnitoWrikeProd: 'forge-connector-390XhSnH4YgwqVgmyqYOujxVoL3IOUcM-wrike',
    ForgeUnitoAsanaDev: 'forge-connector-6wHDDwNbam77WvGwMKYMGDiTWP8pza54-asana',
    ForgeUnitoAsanaProd: 'forge-connector-sFXfxz3XEDS1wAWWCe345UVrSbUm9zyb-asana',
    ForgeUnitoBasecampDev: 'forge-connector-nImlCTNLZUCtQzFsthpnlYJL0B981lMH-basecamp',
    ForgeUnitoBasecampProd: 'forge-connector-TZqLHQtzvKxRikkh1KQlp4acwCzS5W1Z-basecamp'
};
const $2db55438f96b7ddd$export$cc64d659abc3d135 = [
    // Loom is actually a 1P so goes to the top
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Loom,
    // Eventually this might be "smart"
    // For now this static order isn't strongly defined
    $2db55438f96b7ddd$export$93aa518ca2694c2d.GoogleDrive,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Sharepoint,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.OneDrive,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Dropbox,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Slack,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Teams,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Github,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Figma,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.GoogleCalendar,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Gmail,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.OutlookCalendar,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.OutlookMail,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Airtable,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Smartsheet,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Asana,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Zendesk,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Miro,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Docusign,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Lucid,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Monday,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.AzureDevops,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Gitlab,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ConfluenceDC,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Canva,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Box,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Zeplin,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ServiceNow,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Freshservice,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.PowerBI,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ClickUp,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Amplitude,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Stripe,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.AdobeXD,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Aha,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.AdobeSign,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Mural,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Webex,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.PagerDuty,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Pipedrive,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Dovetail,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.LaunchDarkly,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Salesforce,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Sentry,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Gitbook,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.AWSS3,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeAdamVitareqDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeAdamVitareqProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeK15tScrollSitesDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeK15tScrollSitesProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioAwsDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioAwsProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioClickupDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioClickupProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGithubDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGithubProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGitbookDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGitbookProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGitlabDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGitlabProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGoogleDriveDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGoogleDriveProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGuruDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGuruProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioHelpjuiceDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioHelpjuiceProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioHubspotDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioHubspotProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioSalesforceDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioSalesforceProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioSharepointDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioSharepointProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioStackOverflowDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioStackOverflowProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUtoolityGitbookDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUtoolityGitbookProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeGdriveEugeneTestDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeGdriveEugeneTestProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoSalesforceDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoSalesforceProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoServicenowDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoServicenowProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoWrikeDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoWrikeProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoAsanaDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoAsanaProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoBasecampDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoBasecampProd,
    // New 3P? Add it here
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Databricks,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Notion,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Todoist,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Hubspot,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.JiraDC,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.JsmDC,
    // Always last
    $2db55438f96b7ddd$export$93aa518ca2694c2d.AtlassianWebCrawler
];
// TODO: QS-8075 replace into PRODUCTS_ORDER when cleaning up the FG
const $2db55438f96b7ddd$export$915acbd1d0c0550d = [
    // Loom is actually a 1P so goes to the top
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Loom,
    // Eventually this might be "smart"
    // For now this static order isn't strongly defined
    $2db55438f96b7ddd$export$93aa518ca2694c2d.GoogleDrive,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Sharepoint,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Slack,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Teams,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Figma,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Miro,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Salesforce,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Github,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Gmail,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Gitlab,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Lucid,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Asana,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.AzureDevops,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.GoogleCalendar,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.OneDrive,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Dropbox,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.OutlookCalendar,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.OutlookMail,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Airtable,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Smartsheet,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Zendesk,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Docusign,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Databricks,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Monday,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ConfluenceDC,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Canva,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Box,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Zeplin,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ServiceNow,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Freshservice,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.PowerBI,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ClickUp,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Amplitude,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Stripe,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.AdobeXD,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Aha,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.AdobeSign,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Mural,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Webex,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.PagerDuty,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Pipedrive,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Dovetail,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.LaunchDarkly,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Sentry,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Gitbook,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.AWSS3,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Notion,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Todoist,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Hubspot,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.JiraDC,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.JsmDC,
    // New 3P? Add it here
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeAdamVitareqDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeAdamVitareqProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeK15tScrollSitesDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeK15tScrollSitesProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioAwsDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioAwsProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioClickupDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioClickupProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGithubDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGithubProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGitbookDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGitbookProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGitlabDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGitlabProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGoogleDriveDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGoogleDriveProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGuruDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGuruProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioHelpjuiceDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioHelpjuiceProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioHubspotDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioHubspotProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioSalesforceDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioSalesforceProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioSharepointDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioSharepointProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioStackOverflowDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioStackOverflowProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUtoolityGitbookDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUtoolityGitbookProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeGdriveEugeneTestDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeGdriveEugeneTestProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoSalesforceDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoSalesforceProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoServicenowDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoServicenowProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoWrikeDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoWrikeProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoAsanaDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoAsanaProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoBasecampDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoBasecampProd,
    // Always last
    $2db55438f96b7ddd$export$93aa518ca2694c2d.AtlassianWebCrawler
];
const $2db55438f96b7ddd$export$c36c249aaac5cad0 = {
    assignee: [
        $2db55438f96b7ddd$export$93aa518ca2694c2d.JiraDC,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.JsmDC
    ],
    caseStatus: [
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Salesforce
    ],
    closeDate: [
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Salesforce
    ],
    content: [
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ConfluenceDC
    ],
    createdBy: [
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ConfluenceDC,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Hubspot,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Salesforce
    ],
    label: [
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ConfluenceDC
    ],
    lastUpdated: [
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Airtable,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Asana,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.AzureDevops,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Box,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ConfluenceDC,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Databricks,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Docusign,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Dropbox,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Figma,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeAdamVitareqDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeAdamVitareqProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeGdriveEugeneTestDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeGdriveEugeneTestProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeK15tScrollSitesDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeK15tScrollSitesProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioAwsDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioAwsProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioClickupDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioClickupProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGitbookDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGitbookProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGithubDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGithubProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGitlabDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGitlabProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGoogleDriveDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGoogleDriveProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGuruDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGuruProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioHelpjuiceDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioHelpjuiceProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioHubspotDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioHubspotProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioSalesforceDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioSalesforceProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioSharepointDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioSharepointProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioStackOverflowDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioStackOverflowProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoAsanaDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoAsanaProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoBasecampDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoBasecampProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoSalesforceDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoSalesforceProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoServicenowDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoServicenowProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoWrikeDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoWrikeProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUtoolityGitbookDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUtoolityGitbookProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Github,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Gmail,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.GoogleDrive,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Hubspot,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.JiraDC,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.JsmDC,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Loom,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Lucid,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Miro,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Notion,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.OneDrive,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.OutlookMail,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Salesforce,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ServiceNow,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Sharepoint,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Slack,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Smartsheet,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Teams,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Zendesk
    ],
    lastUpdatedBy: [
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Hubspot,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Salesforce
    ],
    opportunityStatus: [
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Salesforce
    ],
    onlyTitleMatch: [
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Airtable,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Asana,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Box,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ConfluenceDC,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Databricks,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Docusign,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Dropbox,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Github,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.GoogleDrive,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Hubspot,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Miro,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Notion,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.OneDrive,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.OutlookMail,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Salesforce,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ServiceNow,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Sharepoint,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Smartsheet,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Zendesk
    ],
    owner: [
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Salesforce
    ],
    project: [
        $2db55438f96b7ddd$export$93aa518ca2694c2d.JiraDC,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.JsmDC
    ],
    pullRequestStatus: [
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGithubDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGithubProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGitlabDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGitlabProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Github,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Gitlab
    ],
    slackChannel: [
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Slack
    ],
    space: [
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ConfluenceDC
    ]
};
module.exports["ProductKeys3P"] = $2db55438f96b7ddd$export$93aa518ca2694c2d;
module.exports["ProductsOrder3P"] = $2db55438f96b7ddd$export$cc64d659abc3d135;
module.exports["NewProductsOrder3P"] = $2db55438f96b7ddd$export$915acbd1d0c0550d;
module.exports["thirdPartyFilterProducts"] = $2db55438f96b7ddd$export$c36c249aaac5cad0;

});

parcelRegister("9d9t8", function(module, exports) {

var $eakyO = parcelRequire("eakyO");

const $320daaf61e2ab33a$export$e88fb694deeca21a = 'smartlinks-connector';
const $320daaf61e2ab33a$export$7ad7a95070d8bb93 = (0, $eakyO.ConnectorSources).Federated;
const $320daaf61e2ab33a$export$e3a0662f044cd99b = (0, $eakyO.ConnectorSources).Lite;
const $320daaf61e2ab33a$export$c14e5e3fa6d8b46 = (0, $eakyO.ConnectorSources).Smartlinks;
const $320daaf61e2ab33a$export$aa06c0b5cc41ad9a = (0, $eakyO.ConnectorSources).Full;
const $320daaf61e2ab33a$export$37e0ed5b7fa94503 = (0, $eakyO.ConnectorSources).Backfill;
const $320daaf61e2ab33a$export$af092ad5a950adea = (value)=>{
    return Object.values((0, $eakyO.ConnectorSources)).includes(value);
};
const $320daaf61e2ab33a$export$9a0cf6dd1d986cc2 = 'forge-connector-';
const $320daaf61e2ab33a$export$e5725489d3388d22 = (type)=>{
    return type.startsWith($320daaf61e2ab33a$export$9a0cf6dd1d986cc2);
};
/**
 * Runtime registry for Forge connector icons.
 * Similar to ThirdPartyConfigs, but populated dynamically from API responses.
 */ const $320daaf61e2ab33a$var$forgeConnectorIconsRegistry = new Map();
const $320daaf61e2ab33a$export$4e96e986802512bd = (productKey, icon)=>{
    $320daaf61e2ab33a$var$forgeConnectorIconsRegistry.set(productKey, icon);
};
const $320daaf61e2ab33a$export$2f2bd8960b497856 = (productKey)=>{
    return $320daaf61e2ab33a$var$forgeConnectorIconsRegistry.get(productKey);
};
const $320daaf61e2ab33a$export$2768da79a2599ca3 = ()=>{
    $320daaf61e2ab33a$var$forgeConnectorIconsRegistry.clear();
};
module.exports["FEDERATED_CONNECTOR_SOURCE"] = $320daaf61e2ab33a$export$7ad7a95070d8bb93;
module.exports["LITE_CONNECTOR_SOURCE"] = $320daaf61e2ab33a$export$e3a0662f044cd99b;
module.exports["SMARTLINKS_CONNECTOR_SOURCE"] = $320daaf61e2ab33a$export$c14e5e3fa6d8b46;
module.exports["FULL_CONNECTOR_SOURCE"] = $320daaf61e2ab33a$export$aa06c0b5cc41ad9a;
module.exports["isConnectorSource"] = $320daaf61e2ab33a$export$af092ad5a950adea;
module.exports["isForgeConnectorProductKey"] = $320daaf61e2ab33a$export$e5725489d3388d22;
module.exports["registerForgeConnectorIcon"] = $320daaf61e2ab33a$export$4e96e986802512bd;
module.exports["getForgeConnectorIcon"] = $320daaf61e2ab33a$export$2f2bd8960b497856;

});

parcelRegister("eakyO", function(module, exports) {
const $b8445082174fc78f$export$499e9a6668a55181 = {
    Federated: 'federated',
    Smartlinks: 'smartlinks',
    Lite: 'lite-connector',
    Full: 'full-connector',
    Backfill: 'backfill'
};
module.exports["ConnectorSources"] = $b8445082174fc78f$export$499e9a6668a55181;

});

parcelRegister("bRblh", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $aXWIB = parcelRequire("aXWIB");


var $tvI67 = parcelRequire("tvI67");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $fVUfS = parcelRequire("fVUfS");


var $7ZiAi = parcelRequire("7ZiAi");

const $760b34ee18927bc0$var$triggerStyles = {
    button: "_1dqoglyw _ca0qu2gc _n3tdu2gc _19bvpxbi _u5f3pxbi _bfhk1j28 _80omtlke _1bsb1osq _irr31dpa",
    text: "_11c8wadc _syaz1rpy"
};
const $760b34ee18927bc0$var$DefaultTrigger = ({ open: open })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        xcss: $760b34ee18927bc0$var$triggerStyles.button,
        onClick: ()=>open()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        alignItems: "center",
        gap: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($tvI67))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $760b34ee18927bc0$var$triggerStyles.text
    }, formatMessage((0, $7ZiAi.messages).defaultTriggerLabel))));
};

const $760b34ee18927bc0$var$LazyRovoSettingsModalProvider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("ebLrv")).then((mod)=>({
            default: mod.RovoSettingsModalLazy
        }))); /**
       * Self-contained entrypoint for the Rovo Settings modal.
       *
       * The trigger renders eagerly. The provider tree and modal
       * are lazy-loaded only when the user first clicks the trigger.
       * Subsequent opens reuse the mounted provider — no re-mount or re-fetch.
       */ 
const $760b34ee18927bc0$export$f2c3f3e62df426ba = ({ children: renderTrigger, ...providerProps })=>{
    const [isActivated, setIsActivated] = (0, $42omo.useState)(false);
    const pendingOpenOptions = (0, $42omo.useRef)(undefined);
    const openModalRef = (0, $42omo.useRef)(null);
    const open = (0, $42omo.useCallback)((options)=>{
        if (openModalRef.current) // Provider already mounted — open directly
        openModalRef.current(options);
        else {
            // First click — store options and mount the provider
            pendingOpenOptions.current = options;
            setIsActivated(true);
        }
    }, []); // Calling the render function directly (rather than mounting it as a
    // component) makes React diff the returned JSX in-place against the previous
    // render, so the trigger element survives parent re-renders even if the
    // render function's identity changes (e.g. inline arrows).
    const triggerNode = renderTrigger ? renderTrigger({
        open: open
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($760b34ee18927bc0$var$DefaultTrigger, {
        open: open
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAJUP.ErrorBoundary), {
        fallbackRender: ()=>null
    }, triggerNode, isActivated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($760b34ee18927bc0$var$LazyRovoSettingsModalProvider, {
        ...providerProps,
        pendingOpenOptions: pendingOpenOptions,
        openModalRef: openModalRef
    })));
};
module.exports["RovoSettingsModal"] = $760b34ee18927bc0$export$f2c3f3e62df426ba;

});

parcelRegister("ebLrv", function(module, exports) {

let $a546e4e3049240ec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a546e4e3049240ec$var$load("hdYRX"),
    $a546e4e3049240ec$var$load("7cXiI"),
    $a546e4e3049240ec$var$load("aXje8"),
    $a546e4e3049240ec$var$load("36RFI"),
    $a546e4e3049240ec$var$load("cRtGo"),
    $a546e4e3049240ec$var$load("6wr18"),
    $a546e4e3049240ec$var$load("jvHRs"),
    $a546e4e3049240ec$var$load("3BYXV"),
    $a546e4e3049240ec$var$load("c251E"),
    $a546e4e3049240ec$var$load("7EorR"),
    $a546e4e3049240ec$var$load("k4cyN"),
    $a546e4e3049240ec$var$load("Wowvf"),
    $a546e4e3049240ec$var$load("ffEVr"),
    $a546e4e3049240ec$var$load("5sTNh"),
    $a546e4e3049240ec$var$load("jOUAD"),
    $a546e4e3049240ec$var$load("6bVVs"),
    $a546e4e3049240ec$var$load("7mo6o"),
    $a546e4e3049240ec$var$load("1SgRc"),
    $a546e4e3049240ec$var$load("jnVKv")
]).then(()=>parcelRequire('7Bg2n'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("dZJhp", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1662I = parcelRequire("1662I");


var $3Klnc = parcelRequire("3Klnc");


var $5G9KX = parcelRequire("5G9KX");

const $7d046d1f45bfe672$var$COOLDOWN_STORAGE_KEY = 'quick_find_connect_apps_cooldown';
const $7d046d1f45bfe672$var$MAX_ANIMATIONS_PER_WEEK = 10;
const $7d046d1f45bfe672$var$DISMISSED_VALUE = 'dismissed';
const $7d046d1f45bfe672$var$getCurrentWeekKey = ()=>{
    const now = new Date();
    // ISO week-year + ISO week so we don't get an off-by-one across a year boundary
    // (e.g. Jan 1 can fall in the previous year's last ISO week).
    return `${(0, $3Klnc.default)(now)}_w${(0, $1662I.default)(now)}`;
};
const $7d046d1f45bfe672$var$readStore = ()=>{
    const raw = (0, $5G9KX.getLocalStorageItemAsString)($7d046d1f45bfe672$var$COOLDOWN_STORAGE_KEY);
    if (!raw) return null;
    try {
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed === 'object' && 'count' in parsed && 'weekKey' in parsed && typeof parsed.count === 'number' && typeof parsed.weekKey === 'string') return parsed;
        return null;
    } catch  {
        // JSON parse error — degrade gracefully.
        return null;
    }
};
const $7d046d1f45bfe672$var$isDismissed = ()=>{
    return (0, $5G9KX.getLocalStorageItemAsString)($7d046d1f45bfe672$var$COOLDOWN_STORAGE_KEY) === $7d046d1f45bfe672$var$DISMISSED_VALUE;
};
const $7d046d1f45bfe672$var$writeStore = (store)=>{
    try {
        (0, $5G9KX.setLocalStorageItem)($7d046d1f45bfe672$var$COOLDOWN_STORAGE_KEY, JSON.stringify(store));
    } catch  {
    // Private browsing / storage full / quota exceeded — degrade gracefully
    // (the animation plays anyway; we just lose the count for this attempt).
    }
};
const $7d046d1f45bfe672$export$92cbac270a4be2e0 = (maxPerWeek = $7d046d1f45bfe672$var$MAX_ANIMATIONS_PER_WEEK)=>{
    const canAnimate = (0, $42omo.useCallback)(()=>{
        if ($7d046d1f45bfe672$var$isDismissed()) return false;
        const weekKey = $7d046d1f45bfe672$var$getCurrentWeekKey();
        const stored = $7d046d1f45bfe672$var$readStore();
        if (stored?.weekKey === weekKey && stored.count >= maxPerWeek) return false;
        return true;
    }, [
        maxPerWeek
    ]);
    const recordAnimation = (0, $42omo.useCallback)(()=>{
        const weekKey = $7d046d1f45bfe672$var$getCurrentWeekKey();
        const stored = $7d046d1f45bfe672$var$readStore();
        const count = stored?.weekKey === weekKey ? stored.count + 1 : 1;
        $7d046d1f45bfe672$var$writeStore({
            weekKey: weekKey,
            count: count
        });
    }, []);
    const dismissPermanently = (0, $42omo.useCallback)(()=>{
        try {
            (0, $5G9KX.setLocalStorageItem)($7d046d1f45bfe672$var$COOLDOWN_STORAGE_KEY, $7d046d1f45bfe672$var$DISMISSED_VALUE);
        } catch  {
        // degrade gracefully
        }
    }, []);
    return {
        canAnimate: canAnimate,
        recordAnimation: recordAnimation,
        dismissPermanently: dismissPermanently
    };
};
module.exports["useConnectAppsCooldown"] = $7d046d1f45bfe672$export$92cbac270a4be2e0;

});


//# sourceMappingURL=PageLayout.ba258f27.js.map
